<div class="backdrop hilCase-modal bg-inherit" style="overflow: hidden">
  <div class="case-details-modal-header">
    <h1 mat-dialog-title>
      {{ "Editduedatedialog.Selectanewduedate" | translate }}
    </h1>
  </div>
  <div class="mat-dialog-content bg-inherit">
    <div class="modal-body">
      <div class="edd-d-flex">
        <div class="edd-w-50">
          <mat-calendar
            [dateFilter]="disableWeekendsFilter"
            [(selected)]="modifiedDueDate"
            [startAt]="selectedStart"
            [minDate]="minDueDate"
            (click)="setFinalTime()"
          >
          </mat-calendar>
        </div>
        <div class="edd-right-bar">
          <div class="edd-enter-time">
            <label for="dueTime" class="entertime">
              {{ "Editduedatedialog.EnterTime" | translate }}
            </label>
          </div>
          <div class="edd-d-flex">
            <div class="search_input">
              <input
                #timeInput
                type="time"
                class="edd-enter-time-input"
                min="01:00"
                max="12:00"
                [(ngModel)]="modifiedTime"
                (change)="onTimeChange($event.target)"
                [value]="minTime"
                #timeField="ngModel"
                (keydown)="onKeyUpChange($event)"
                required
                [ngClass]="{
                  timeErrorBrd: timeField.errors?.required || overCurrTime || overCurrTimeDt
                }"
              />
            </div>
            <div class="edd-am-pm">
              <button
                mat-button
                id="edd-am-btn"
                class="edd-am-btn edd-am-pm-btn"
                (click)="isAMFlag = true; setFinalTime()"
                [ngClass]="isAMFlag ? 'my-active-btn' : ''"
              >
                {{ "Editduedatedialog.AM" | translate }}
              </button>
              <button
                mat-button
                class="edd-pm-btn edd-am-pm-btn"
                id="edd-pm-btn"
                (click)="isAMFlag = false; setFinalTime()"
                [ngClass]="!isAMFlag ? 'my-active-btn' : ''"
              >
                {{ "Editduedatedialog.PM" | translate }}
              </button>
            </div>
          </div>
          <p class="errMessage">{{errorMessage}}</p>
          <div class="edd-new-dd">
            <p class="edd-fw-bolder">
              {{ "Editduedatedialog.NewDueDate" | translate }}
            </p>
            <div class="edd-new-dd-spans">
              <span>{{ modifiedTime }}</span> &nbsp;
              <span class="">{{ isAMFlag ? "AM" : "PM" }}</span> &nbsp;
              <span id="modifiedDueDate">{{
                modifiedDueDate | date: "MM/dd/yyyy"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="buttons">
        <button class="cancelbtn" (click)="onCancel()">
          {{ "Editduedatedialog.Cancel" | translate }}
        </button>
        <button class="my-active btn-SN-primary" (click)="onSubmit()" 
        [ngClass]=" overCurrTimeDt || overCurrTime ? 'submission-disabled' : '' " [disabled]="overCurrTimeDt || overCurrTime">
          {{ "Editduedatedialog.Submit" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
